export const statusArquivo = {
    // Campo id existe apenas para facilitar identificação back -> mesmo nome ENum.
    0: {
        tipo: 'default',
        tooltip: 'Importação iniciada',
        titulo: 'Aguardando',
        id: 'Aguardando'
    },
    1: {
        tipo: 'waiting',
        tooltip: 'Arquivo aguardando para ser identificado e processado',
        titulo: 'Aguardando processamento',
        id: 'AguardandoProcessamento'
    },
    2: {
        tipo: 'processing',
        tooltip: 'Arquivo em processo de identificação e leitura',
        titulo: 'Processando',
        id: 'Processando'
    },
    3: {
        tipo: 'success',
        tooltip: 'Arquivo lido e processado',
        titulo: 'Finalizado',
        id: 'Finalizado'
    },
    4: {
        tipo: 'error',
        tooltip: 'Não foi possível realizar a leitura do arquivo',
        titulo: 'Erro',
        id: 'Erro'
    },
    5: {
        tipo: 'error',
        tooltip: 'Arquivo inválido. Por favor, verifique a extensão dos arquivos carregados.',
        titulo: 'Erro',
        id: 'ErroArquivoInvalido'
    },
    6: {
        tipo: 'error',
        tooltip: 'Relatório não pertence ao segurado cadastrado.',
        titulo: 'Erro',
        id: 'ErroCPFInvalido'
    },
    7: {
        tipo: 'error',
        tooltip: 'O período de importação carregado ultrapassa os últimos 5 anos.',
        titulo: 'Erro',
        id: 'ErroCompetenciaMaior5Anos'
    },
    8: {
        tipo: 'error',
        tooltip: 'Competência já importada.',
        titulo: 'Erro',
        id: 'ErroCompetenciaDuplicada'
    },
    9: {
        tipo: 'error',
        tooltip: 'Segurado não cadastrado.',
        titulo: 'Erro',
        id: 'ErroSeguradoNaoCadastrado'
    },
    10: {
        tipo: 'error',
        tooltip: 'Ocorreu um erro na leitura do arquivo.',
        titulo: 'Erro',
        id: 'ErroLeitura'
    },
    11: {
        tipo: 'error',
        tooltip: 'Arquivo CNIS já importado.',
        titulo: 'Erro',
        id: 'ErroCNISDuplicado'
    },
    12: {
        tipo: 'error',
        tooltip: 'Arquivo inválido',
        titulo: 'Erro',
        id: 'ErroLeiauteInvalido'
    }
}

export const nomesMeses = {
    1: 'JAN',
    2: 'FEV',
    3: 'MAR',
    4: 'ABR',
    5: 'MAI',
    6: 'JUN',
    7: 'JUL',
    8: 'AGO',
    9: 'SET',
    10: 'OUT',
    11: 'NOV',
    12: 'DEZ'
}